import { useMemo, useState } from 'react';

/**
 * Shared hook for list-page filter state (active, search, pagination).
 * Use with any list API that accepts { page, pageSize, isActive?, search? }.
 *
 * @param {number} [initialPageSize=10]
 * @returns {{ activeState, setActiveState, page, setPage, search, setSearch, pageSize, filters, setPageToOne }}
 */
export function useListFilters(initialPageSize = 10) {
  const [activeState, setActiveState] = useState('all');
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const pageSize = initialPageSize;

  const filters = useMemo(() => {
    const base = { page, pageSize };
    if (activeState === 'active') base.isActive = true;
    else if (activeState === 'inactive') base.isActive = false;
    if (search.trim()) base.search = search.trim();
    return base;
  }, [page, pageSize, activeState, search]);

  const setPageToOne = () => setPage(1);

  return {
    activeState,
    setActiveState,
    page,
    setPage,
    search,
    setSearch,
    pageSize,
    filters,
    setPageToOne,
  };
}

export default useListFilters;
